"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConversationListWithNewConversationList = exports.updateConversationListWithMessage = exports.enrichMessages = exports.fetchLinkPreview = void 0;
const parser_1 = require("./parser");
const fetchLinkPreview = (apiUrl, linkPreviewUrl) => fetch(`${apiUrl}?url=${encodeURIComponent(linkPreviewUrl)}`, {
    headers: {
        'Content-Type': 'application/json',
    },
})
    .then((response) => response.json())
    .then(parser_1.parseLinkPreview);
exports.fetchLinkPreview = fetchLinkPreview;
const isSameDay = (date1, date2) => {
    const dateA = new Date(date1);
    const dateB = new Date(date2);
    return (dateA.getDate() === dateB.getDate() &&
        dateA.getMonth() === dateB.getMonth() &&
        dateA.getFullYear() === dateB.getFullYear());
};
const enrichMessages = (messages, ownProfileGid) => {
    return messages.map((message, index) => {
        const isOwn = message.author.gid === ownProfileGid;
        const isLastItem = index === messages.length - 1;
        const isLastOfAuthorGroup = isLastItem ||
            messages[index + 1].author.gid !== messages[index].author.gid;
        const previousMessageIsSameDay = index > 0 && isSameDay(message.createdAt, messages[index - 1].createdAt);
        return Object.assign(Object.assign({}, message), { isLastOfAuthorGroup,
            isOwn,
            previousMessageIsSameDay });
    });
};
exports.enrichMessages = enrichMessages;
const updateConversationListWithMessage = (conversations, message, currentConversationId) => {
    const conversation = conversations.find((c) => c.id === currentConversationId);
    if (!conversation)
        return [];
    const filteredConversations = conversations.filter((c) => c.id !== currentConversationId);
    const updatedConversation = Object.assign(Object.assign({}, conversation), { latestMessage: message, meta: Object.assign(Object.assign({}, conversation.meta), { unreadMessageCount: conversation.id !== currentConversationId &&
                conversation.id === message.conversation.id
                ? conversation.meta.unreadMessageCount + 1
                : conversation.meta.unreadMessageCount }), updatedAt: new Date() });
    return [updatedConversation, ...filteredConversations];
};
exports.updateConversationListWithMessage = updateConversationListWithMessage;
const updateConversationListWithNewConversationList = (oldList, newList) => {
    const updatedOldList = oldList.map((oldConversation) => {
        const updatedConversation = newList.find((newConversation) => oldConversation.gid === newConversation.gid);
        return updatedConversation !== null && updatedConversation !== void 0 ? updatedConversation : oldConversation;
    });
    const filteredNewList = newList.filter((newConversation) => updatedOldList.every((oldConversation) => newConversation.gid !== oldConversation.gid));
    return [...updatedOldList, ...filteredNewList];
};
exports.updateConversationListWithNewConversationList = updateConversationListWithNewConversationList;
